// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__3B6Cz","select":"Header_select__26fs9","clinic":"Header_clinic__2PC9a"};